import {getStorableInfosFromTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export default function extractStorableId(storableTypedValue: TypedValue | null): string | null {
  const storableInfos = getStorableInfosFromTypedValue(storableTypedValue);
  if (storableInfos.length === 0) {
    return null;
  } else if (storableInfos.length > 1) {
    return null;
  }

  const [storableInfo] = storableInfos;
  return storableInfo.id;
}
